const script = [
  {
    role: "user",
    meta: "Support overlay · 00:01",
    text: "Our checkout is stalling after 3D Secure. Can you resume the session?",
  },
  {
    role: "agent",
    meta: "Essenize agent · streaming",
    text: "Session recovered. I am attaching the payment knowledge path and opening a live stream to the checkout service logs.",
  },
  {
    role: "agent",
    meta: "Tool · knowledge path",
    text: "Matched flow: payments.3ds.resume → escalate if latency > 800ms. Database: customer-owned Postgres. Backend: existing Restora chat adapter.",
  },
];

export function initChatDemo() {
  const stream = document.querySelector("[data-chat-stream]");
  if (!stream) return;

  let i = 0;
  const add = () => {
    if (i >= script.length) return;
    const item = script[i];
    const bubble = document.createElement("div");
    bubble.className = `bubble ${item.role}`;
    bubble.innerHTML = `<span class="meta">${item.meta}</span>${item.text}`;
    stream.appendChild(bubble);
    i += 1;
    if (i < script.length) setTimeout(add, 1400);
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      add();
      observer.disconnect();
    }
  });
  observer.observe(stream);
}
